// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import persistConfig from './persistConfig';
import authReducer from '../features/auth/authSlice';
import buyerReducer from '../features/buyer/buyerSlice';
import userReducer from '../features/user/userSlice';
import sellerReducer from '../features/seller/sellerSlice';
import uiReducer from '../features/buyer/uiSlice';
import sellerUiReducer from '../features/seller/sellerUiSlice'; 

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  auth: authReducer,
  user:userReducer,
  buyer: buyerReducer,
  seller:sellerReducer,
  ui: uiReducer,
  sellerUi: sellerUiReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
});

export const persistor = persistStore(store);
